import Immutable from 'immutable';
import { FLAG_TOTAL_POS_ACTIVITY } from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_TOTAL_POS_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
